import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { GetMagnetKeyInfo, MagnetDynamicReport, PostMagnetSetKeyInfo } from './magnet_set'
import { DataDeadZone, PostMagnetSetKeyDeadZone } from '@libs/types/response'
import { KK } from '@/define/define'

// 发送的数据进行转换
export const convertTravelToSend_Above6800 = (info: PostMagnetSetKeyInfo) => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    if (info.PressNum > 0) info.PressNum = (info.PressNum * 2) / 10
    if (info.ReleaseNum > 0) info.ReleaseNum = (info.ReleaseNum * 2) / 10
    if (info.QuickTriggerPressNum > 0) info.QuickTriggerPressNum = (info.QuickTriggerPressNum * 2) / 10
    if (info.QuickTriggerReleaseNum > 0) info.QuickTriggerReleaseNum = (info.QuickTriggerReleaseNum * 2) / 10
  }
  return info
}
// 获取回来的数据进行转换
export const convertTravelFromReceive_Above6800 = (data: GetMagnetKeyInfo[]) => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    data.forEach((item) => {
      if (item.PressNum > 0) item.PressNum = (item.PressNum / 2) * 10
      if (item.ReleaseNum > 0) item.ReleaseNum = (item.ReleaseNum / 2) * 10
      if (item.QuickTriggerPressNum > 0) item.QuickTriggerPressNum = (item.QuickTriggerPressNum / 2) * 10
      if (item.QuickTriggerReleaseNum > 0) item.QuickTriggerReleaseNum = (item.QuickTriggerReleaseNum / 2) * 10
    })
  }
  return data
}
// 发送的死区数据进行转换
export const convertDeadZoneToSend_Above6800 = (setData: PostMagnetSetKeyDeadZone) => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    setData.Top = (setData.Top * 2) / 10
    setData.Bottom = (setData.Bottom * 2) / 10
  }
  return setData
}
// 获取回来的死区数据进行转换
export const convertDeadZoneFromReceive_Above6800 = (data: { [key: KK]: DataDeadZone }) => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    for (const key in data) {
      const item = data[key]
      item.Top = (item.Top / 2) * 10
      item.Bottom = (item.Bottom / 2) * 10
    }
  }
  return data
}
// 校准时行程转换
export const convertTravelForCalibration = (res: MagnetDynamicReport[]) => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    res.map((item) => {
      if (item.Value > 0) item.Value *= 10
    })
  }
  return res
}
// 导入配置时行程转换
export const importConfigTravelClampValue = (value: number, min: number, max: number): number => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    return (Math.max(min, Math.min(value, max)) * 2) / 10
  }
  return Math.max(min, Math.min(value, max))
}
